/**
 * Access Tier and Entitlements Configuration for AIxEnergy Studio.
 * Mirrors docs/membership-gating.md across the AIxEnergy platform.
 */

import { AccessTier } from "../types";

export const ACCESS_TIERS: AccessTier[] = [
  "guest",
  "free_member",
  "journal",
  "map_seat",
  "studio_pro",
  "admin",
];

export const TIER_LABELS: Record<AccessTier, string> = {
  guest: "Guest Visitor",
  free_member: "Free Member",
  journal: "Journal Subscriber ($300/yr)",
  map_seat: "Map Executive ($25k/yr)",
  studio_pro: "Studio Pro ($1,500/mo)",
  admin: "AIxEnergy Staff (Admin)",
};

export const TIER_BADGES: Record<AccessTier, { text: string; bg: string; border: string; color: string }> = {
  guest: { text: "GUEST", bg: "bg-slate-800/80", border: "border-slate-700", color: "text-slate-400" },
  free_member: { text: "FREE MEMBER", bg: "bg-blue-950/80", border: "border-blue-700/50", color: "text-blue-400" },
  journal: { text: "JOURNAL", bg: "bg-emerald-950/80", border: "border-emerald-700/50", color: "text-emerald-400" },
  map_seat: { text: "MAP SEAT", bg: "bg-purple-950/80", border: "border-purple-700/50", color: "text-purple-400" },
  studio_pro: { text: "STUDIO PRO", bg: "bg-amber-950/80", border: "border-amber-500", color: "text-amber-400" },
  admin: { text: "STAFF MASTER", bg: "bg-red-950/80", border: "border-red-500", color: "text-red-400" },
};

export function maxCompsAllowed(tier: AccessTier): number {
  switch (tier) {
    case "guest": return 10;
    case "free_member": return 25;
    default: return 999999;
  }
}

export function maxRadarAllowed(tier: AccessTier): number {
  switch (tier) {
    case "guest": return 3;
    case "free_member": return 5;
    case "journal": return 15;
    default: return 999999;
  }
}

export function canSaveScenarios(tier: AccessTier): { allowed: boolean; max: number } {
  switch (tier) {
    case "guest": return { allowed: false, max: 0 };
    case "free_member": return { allowed: true, max: 1 };
    case "journal": return { allowed: true, max: 5 };
    case "map_seat": return { allowed: true, max: 10 };
    default: return { allowed: true, max: 999999 };
  }
}

export function canExportCleanPdf(tier: AccessTier): boolean {
  return tier === "studio_pro" || tier === "admin" || tier === "map_seat";
}

export function isBlurredRadarRow(index: number, tier: AccessTier): boolean {
  if (tier === "studio_pro" || tier === "admin" || tier === "map_seat") return false;
  return index >= maxRadarAllowed(tier);
}
